document.addEventListener("DOMContentLoaded", () => {
  // ==== CONFIG ====
  // URL prefix for each market on koranm.com ("" = root = India)
  const prefixes = {
    IN: "",
    GB: "/en-gb",
    US: "/en-us",
  };
  const INTL = "/en-int";                     // every other country
  const IP_API_KEY = "VxB5iAacNcGXZ7X";   // your ip-api.com Pro key
  const SKIP_PATHS = [];                      // paths without prefix, e.g. ["/pages/contact"]
  // ================

  const s = location.search.toLowerCase();
  const path = location.pathname;
  const S = window.Shopify || {};

  // Never show the popup to crawlers (Googlebot, Merchant Center, AdsBot, etc.)
  const isBot = /bot|crawl|spider|slurp|google|bing|yandex|baidu|duckduck|facebookexternalhit|lighthouse|mediapartners/i
    .test(navigator.userAgent);
  if (isBot) return;

  // Which market is the visitor on now, and the path without the prefix
  const match = path.match(/^\/(en-gb|en-us|en-int)(?=\/|$)/i);
  const currentPrefix = match ? "/" + match[1].toLowerCase() : "";   // "" = India
  const rest = path.slice(match ? match[0].length : 0) || "/";      // e.g. "/products/abc"

  // Skip currency links, theme previews/editor and excluded pages
  if (s.includes("currency=")) return;
  if (
    s.includes("preview_theme_id") || s.includes("preview") || s.includes("editor") ||
    rest.toLowerCase().includes("/apps/theme-editor") || S.designMode || S.previewMode ||
    SKIP_PATHS.includes(rest.toLowerCase())
  ) return;

  const showPopup = (c) => {
    if (!c) return;
    const target = c in prefixes ? prefixes[c] : INTL;

    // Already on the right market?
    if (currentPrefix === target) return;

    const overlay = document.getElementById("overlay");
    const okButton = document.getElementById("okButton");
    if (!overlay || !okButton) return;

    overlay.style.display = "flex";
    document.body.classList.add("overflow-hidden");

    okButton.onclick = () => {
      const newPath = target + (rest === "/" && target ? "" : rest) || "/";
      location.href = `${location.origin}${newPath}${location.search}${location.hash}`;
    };
  };

  // Reuse the country for this visit instead of calling the API on every page
  let cached = null;
  try { cached = sessionStorage.getItem("geo_cc"); } catch (e) {}
  if (cached) return showPopup(cached);

  fetch(`https://pro.ip-api.com/json/?key=${IP_API_KEY}&fields=countryCode`)
    .then((r) => r.json())
    .then(({ countryCode: c }) => {
      try { sessionStorage.setItem("geo_cc", c); } catch (e) {}
      showPopup(c);
    })
    .catch((e) => console.error("Failed to get geo-location:", e));
});
